export const CUSTOMER_SETTINGS_ALL_USER_REDUCER_NAME = 'allUsers'
export const CUSTOMER_SETTINGS_POST_USER_REDUCER_NAME = 'postUser'
